export const SUBSCRIPTION_TYPES = [
  {
    name: 'ONE-OFF',
    value: 'ONCE',
    label: 'admin.serviceCatalog.subscriptionType.onlyOnce'
  },
  {
    name: 'CUSTOM',
    value: 'CUSTOM',
    label: 'app.common.custom'
  }
  // {
  //   name: 'MONTHLY',
  //   value: 'MONTHLY',
  //   label: 'admin.serviceCatalog.subscriptionType.monthly'
  // },
  // {
  //   name: 'ANNUALLY',
  //   value: 'ANNUALLY',
  //   label: 'admin.serviceCatalog.subscriptionType.annually'
  // }
];
export const BLOCK_HOUR_SUBSCRIPTION_TYPES = [
  // {
  //   name: 'MONTHLY',
  //   value: 'MONTHLY',
  //   label: 'admin.serviceCatalog.subscriptionType.monthly'
  // },
  {
    name: 'PERPETUAL',
    value: 'PERPETUAL',
    label: 'admin.serviceCatalog.subscriptionType.perpetual'
  },
  {
    name: 'CUSTOM',
    value: 'CUSTOM',
    label: 'app.common.custom'
  }
];
export const BLOCK_HOUR_TYPES = [
  {
    name: 'ALL_HOURS',
    value: 'ALL_HOURS',
    label: 'admin.serviceCatalog.blockHourTypes.allHours'
  },
  {
    name: 'BUSINESS_HOURS',
    value: 'BUSINESS_HOURS',
    label: 'admin.serviceCatalog.blockHourTypes.businessHours'
  }
];

export const QUANTITY_OPTIONS = [
  {
    name: 'CUSTOM',
    value: 'CUSTOM',
    label: 'admin.serviceCatalog.quantity.custom'
  },
  {
    name: 'ALL_USER',
    value: 'ALL_USER',
    label: 'admin.serviceCatalog.quantity.allUsers'
  },
  {
    name: 'ASSET_VIEW',
    value: 'ASSET_VIEW',
    label: 'admin.serviceCatalog.quantity.assets'
  },
  {
    name: 'INTEGRATION_USAGE',
    value: 'INTEGRATION_USAGE',
    label: 'admin.serviceCatalog.quantity.integrationUsage'
  }
];
export const CUSTOM_SUBSCRIPTION_TYPES = [
  {
    name: 'DAY',
    value: 'DAY',
    label: 'Days'
  },
  {
    name: 'WEEK',
    value: 'WEEK',
    label: 'Week'
  },
  {
    name: 'MONTH',
    value: 'MONTH',
    label: 'Month'
  },
  {
    name: 'YEAR',
    value: 'YEAR',
    label: 'Year'
  }
];

export const EXCLUDE_END_DATE_CATEGORIES = ['PERPETUAL', 'ONE-OFF'];

export const EXCLUDE_CONTRACT_RECURRING_MODE = ['UPFRONT', 'ADVANCE'];
